var $fcb076bca0c74b0d$exports = {};
$fcb076bca0c74b0d$exports = {
    "invalidSelection": (args, formatter)=>`Valgte ${formatter.plural(args.selectedCount, {
            one: `dato`,
            other: `datoer`
        })} ikke ledige.`
};


export {$fcb076bca0c74b0d$exports as default};
//# sourceMappingURL=da-DK.mjs.map
